import { render, staticRenderFns } from "./MediaDisplayerList.vue?vue&type=template&id=23b040eb"
import script from "./MediaDisplayerList.vue?vue&type=script&lang=js"
export * from "./MediaDisplayerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports